import { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { Severity } from './buildTurnIssues';

export type SummaryTone = Severity | 'info';

const TONE_LABEL_KEY: Record<SummaryTone, string> = {
  error: 'common.error',
  warning: 'common.warning',
  info: 'try_it.turn_highlights.title',
};

const TONE_CLASS: Record<SummaryTone, string> = {
  error: 'border-destructive',
  warning: 'border-warning',
  info: 'border-informational',
};

export const SummarySection = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className="flex w-full flex-col gap-2">
    <span className="text-sm leading-5 font-semibold text-foreground-muted">{title}</span>
    <div className="flex w-full flex-col">{children}</div>
  </div>
);

export const SummaryRow = ({
  tone,
  isLast,
  children,
}: {
  tone: SummaryTone;
  isLast: boolean;
  children: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-2 self-stretch">
      <div className="flex w-2.5 shrink-0 flex-col items-center gap-1 self-stretch pt-1 pb-0.5">
        <span className={cn('size-2.5 shrink-0 rounded-full border-2', TONE_CLASS[tone])}>
          <span className="sr-only">{t(TONE_LABEL_KEY[tone])}</span>
        </span>
        {!isLast && <div className="w-px flex-1 bg-stroke" />}
      </div>
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-wrap items-center gap-1 text-sm leading-5 text-foreground',
          !isLast && 'pb-4'
        )}
      >
        {children}
      </div>
    </div>
  );
};
